module.exports = __webpack_public_path__ + "assets/icons/favicon-auction-36ca.ico";